<header class="cat-header">
    <div class="container">
        <div class="row align-center">
            <div class="col-md-12">
                <div class="cat-box text-right">
                    <h3 class="main-title">
                        اختر القسم الذي يناسب نشاطك
                    </h3>
                    <p>
                        يمكنك اختيار القسم من هذه القائمة.
                    </p>
                </div>
            </div>
        </div>
    </div>
</header>